<template>
	<div class="page">
		<HeaderBar title="血清甲胎蛋白"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400xqjtdb.guid">
					<checkItem v-for="(item,index) in dataList" :key="index" :config="item" @setFormData="setFormData"
						v-model="form.bq400xqjtdb">
					</checkItem>
				</van-cell-group>
				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq400xqjtdb.guid' disabled>
				</FormNormalUpload>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page006",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400xqjtdb',
				form: {
					bq400xqjtdb: {
						id: "", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400106: "", //血清甲胎蛋白
						bq4001062: "", //值
						bq4001063: "", //单位
						Bq400_guid: '', //随访基本信息表编号
						Bq400_106: '', //血清甲胎蛋白
						Bq400_106_2: '', //值
						Bq400_106_3: '', //单位
					},
					sempFiles: []
				},

				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400xqjtdb/Save',
				dataList: [],
				bq400: JSON.parse(sessionStorage.getItem('bq400'))
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400xqjtdb/Info', args, function(d) {
					let dataModel = d.Data
					if (dataModel != null) {
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$set(that.form, "bq400xqjtdb", dataModel)
					}
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			this.form.bq400xqjtdb.bq400guid = this.bq400.guid
			this.LoadDataList()
			this.LoadInfo()
		}
	}
</script>

<style scoped>

</style>
